import React from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import blogA from "./assets/img/ugph_1.jpg";
import blogB from "./assets/img/ugph_2.jpg";
import blogD from "./assets/img/ugph_4.jpg";
import { Carousel } from "react-responsive-carousel";
import blogC from "./assets/img/ugph_3.jpg";
// core components

const items = [
  {
    src: blogA,
  },
  {
    src: blogB,
  },
  {
    src: blogC,
  },
  {
    src: blogD,
  },
];

function CarouselSection() {
  return (
    <>
      <Carousel
        infiniteLoop
        autoPlay
        showArrows={false}
        showIndicators={false}
        showThumbs={false}
        showStatus={false}
      >
        {items.map((item, key) => {
          return (
            <div
              className="page-header section-height-75"
              style={{ backgroundImage: "url(" + item.src + ")" }}
              key={key}
            >
              <span className="mask bg-gradient-green" />
            </div>
          );
        })}
      </Carousel>
    </>
  );
}

export default CarouselSection;
